import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import Joyride from 'react-joyride';
import { useSelector } from 'react-redux';
import { generalAlertError } from '../../common/utils/alerts';
import { listSendDocuments, resetSendDocuments } from '../../features/afterSale/afterSaleActions';
import Pagination from '../../common/components/elements/Pagination';
// import { useTourContext } from '../../context/useTourContext';
import ErrorComponent from '../../common/components/ErrorComponent';
// import { joyrideOptions } from '../../common/utils/joyrideUtils';
// import { handleCallbackSendDocuments } from '../../common/utils/joyrideCallbacks';
// import { sendDocumentsSteps } from '../../common/utils/joyrideSteps';
import {
  SendDocumentsPageStyles,
  PageHeader,
  HeaderActions,
  SendDocumentCard,
  FilterCard,
  SearchButton,
  EmptyState,
  LoadingState,
  SendDocumentsList,
  InfoChip,
  PostSaleButton,
} from './SendDocumentsPage.styles';

export function SendDocumentsPage() {
  const navigate = useNavigate();
  const state = useSelector((store) => store.afterSale.send_documents_page);

  const {
    loading, send_documents, total_pages, page_number, error,
  } = state;

  const [search, setSearch] = useState({
    search: '',
    date_from: '',
    date_to: '',
  });
  // const [steps, setSteps] = useState([]);

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('sendDocuments') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('sendDocuments')]);

  // const fireNewQuoteTour = () => {
  //   localStorage.removeItem('sendDocuments');
  //   setState({ run: true, tourActive: true });
  // };

  // useEffect(() => {
  //   sendDocumentsSteps(send_documents, setSteps);
  // }, [send_documents]);

  useEffect(() => {
    (async () => {
      listSendDocuments(1, search);
    })();

    return () => {
      resetSendDocuments();
    };
  }, []);

  const handleChange = ({ target: { value, name } }) => {
    setSearch({ ...search, [name]: value });
  };

  const searchHandler = async (e) => {
    e.preventDefault();

    if (search.date_from !== '' && search.date_to === '') {
      generalAlertError('Devi selezionare anche data al');
      return;
    }

    if (search.date_from === '' && search.date_to !== '') {
      generalAlertError('Devi selezionare anche data da');
      return;
    }

    const trimmedSearch = {
      ...search,
      search: search.search.trim(),
    };

    listSendDocuments(1, trimmedSearch);
  };

  return error === null ? (
    <SendDocumentsPageStyles>
      {/* <Joyride
        steps={steps}
        continuous
        showBeacon={showBeacon}
        locale={{
          back: 'Indietro',
          close: 'Chiudi',
          last: 'Fine',
          next: 'Prossima',
          open: 'Apri il modale',
          restart: 'Riavvia il tour ',
          skip: 'Salta',
        }}
        styles={{
          options: joyrideOptions,

          buttonNext: {
            backgroundColor: '#00a651',
            outline: 'none',
          },
          buttonBack: {
            color: '#00a651',
            outline: 'none',
          },
          beaconInner: {
            backgroundColor: '#00a651',
          },
          beaconOuter: {
            borderColor: '#00a651',
            backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
          },
          buttonSkip: {
            outline: 'none',
          },
          buttonClose: {
            outline: 'none',
          },
        }}
        run={run}
        callback={(data) => handleCallbackSendDocuments(data, steps, setState)}
        showSkipButton
        showProgress
      /> */}
      <div className="container-fluid">
        <PageHeader>
          <h2>📧 Documenti Inviati</h2>
          <HeaderActions>
            <PostSaleButton onClick={() => navigate('/after-sale/select')}>
              Vai a Post Vendita
            </PostSaleButton>
            {/* {localStorage.getItem('sendDocuments') === 'done' && (
              <PostSaleButton onClick={() => fireNewQuoteTour()}>
                Tutorial
              </PostSaleButton>
            )} */}
          </HeaderActions>
        </PageHeader>

        <div className="row">
          {/* Main Content */}
          <div className="col-lg-7 col-xl-8 col-xxl-9 order-2 order-lg-1">
            {loading ? (
              <LoadingState className="send-documents-one">
                <div className="spinner-border" role="status" />
                <span>Caricamento documenti in corso...</span>
              </LoadingState>
            ) : (
              <>
                <SendDocumentsList className="send-documents-one">
                  {send_documents.length > 0 ? (
                    send_documents.map((send_document) => (
                      <SendDocumentCard
                        key={send_document.id}
                        className="send-documents-two"
                      >
                        <div className="d-flex flex-column">
                          <div className="send-document-content">
                            <div className="customer-name">
                              👤
                              {' '}
                              {send_document.quotation.insurance_request.customer.gender !== 'G'
                                ? `${send_document.quotation.insurance_request.customer.name} ${send_document.quotation.insurance_request.customer.surname}`
                                : send_document.quotation.insurance_request.customer.business_name}
                            </div>

                            <div className="send-document-details">
                              <div className="info-chips-row">
                                {send_document.quotation.insurance_request.product && (
                                  <InfoChip $highlight>
                                    📦
                                    {' '}
                                    {send_document.quotation.insurance_request.product.name}
                                  </InfoChip>
                                )}

                                {send_document.quotation.company && (
                                  <InfoChip>
                                    🏢
                                    {' '}
                                    {send_document.quotation.company.name}
                                  </InfoChip>
                                )}

                                {send_document.quotation.preventivas_company && (
                                  <InfoChip>
                                    🏢
                                    {' '}
                                    {send_document.quotation.preventivas_company.company_name}
                                  </InfoChip>
                                )}

                                {send_document.quotation.insurance_request.vehicle && (
                                  <InfoChip $highlight>
                                    🚗
                                    {' '}
                                    {send_document.quotation.insurance_request.vehicle.vehicle_plate}
                                  </InfoChip>
                                )}
                              </div>

                              <div className="email-info">
                                ✉️ Email:
                                {' '}
                                {send_document.email}
                              </div>

                              <div className="created-date">
                                🕐 Creato il
                                {' '}
                                {new Date(send_document.created_at).toLocaleDateString('it-IT', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </SendDocumentCard>
                    ))
                  ) : (
                    <EmptyState className="send-documents-no-result">
                      <div className="empty-icon">📭</div>
                      <h5>Nessun documento inviato trovato!</h5>
                      <p>Prova a modificare i filtri di ricerca</p>
                    </EmptyState>
                  )}
                </SendDocumentsList>

                <div className="mt-4">
                  <Pagination
                    total_pages={total_pages}
                    current_page={page_number}
                    onClick={listSendDocuments}
                    search={search}
                  />
                </div>
              </>
            )}
          </div>

          {/* Filters Sidebar */}
          <div className="col-lg-5 col-xl-4 col-xxl-3 order-1 order-lg-2 mb-4 mb-lg-0">
            <FilterCard className="send-documents-three">
              <h5>🔍 Filtri di Ricerca</h5>
              <form
                onSubmit={searchHandler}
                className="d-flex flex-column gap-3"
              >
                <div>
                  <label htmlFor="search">Ricerca cliente</label>
                  <input
                    type="text"
                    name="search"
                    id="search"
                    className="form-control"
                    value={search.search}
                    onChange={handleChange}
                    placeholder="Nome, cognome..."
                  />
                </div>

                <div>
                  <label htmlFor="date_from">Data creazione da</label>
                  <input
                    type="date"
                    name="date_from"
                    id="date_from"
                    onChange={handleChange}
                    value={search.date_from}
                    className="form-control"
                    lang="it-IT"
                  />
                </div>

                <div>
                  <label htmlFor="date_to">Data creazione al</label>
                  <input
                    type="date"
                    name="date_to"
                    id="date_to"
                    className="form-control"
                    onChange={handleChange}
                    value={search.date_to}
                    min={search.date_from}
                    lang="it-IT"
                  />
                </div>

                <SearchButton type="submit">
                  Cerca
                </SearchButton>
              </form>
            </FilterCard>
          </div>
        </div>
      </div>
    </SendDocumentsPageStyles>
  ) : (
    <ErrorComponent error={error} />
  );
}
